<div class="d-flex justify-content-between mb-2 px-2">
	<h2>{{'connectivity_verification.title' | translate}}</h2>
	<a routerLink="/admin-panel/connectivity-verification-statistics"><button class="btn btn-primary mb-3" type="button">{{"connectivity_verification.statistics" | translate}}</button></a>
</div>

<details open class="mb-2" *ngIf="!reportId">
	<summary>{{'g.filter_box' | translate}}</summary>
		<!-- filters -->
	<div class="filter-box white-field col-12">
		<div *ngIf="!isValidPeriod" class="alert alert-danger mb-2">
			{{'connectivity_verification.invalid_period' | translate}}
		</div>

		<div class="custom-row">
			<!-- device family -->
			<div class="filter">
				<label for="device_family">{{'connectivity_verification.device_family' | translate}}</label>
				<ng-select
					[(ngModel)]="selectedDeviceFamily"
					[items]="deviceFamiliesList"
					name="device_family"
					bindValue="id"
					bindLabel="name"
					[clearable]="false"
					[ngStyle]="{'width': '150px'}"
				></ng-select>
			</div>
		</div>

		<div class="custom-row">
			<!-- start Period -->
			<div class="filter">
				<strong>{{'g.from' | translate}}</strong>
				<div class="d-flex mt-2">
					<div class="mr-2">
						<label for="start_period_year">{{'g.year' | translate}}</label>
						<ng-select
							[(ngModel)]="filter.startPeriod.year"
							[items]="filtersList.startPeriod.years"
							name="start_period_year"
							bindValue="id"
							bindLabel="name"
							[clearable]="false"
							[ngStyle]="{'width': '150px'}"
							placeholder="{{'g.year_option' | translate}}"
							(click)="onSelectPeriod()"
						></ng-select>
					</div>
					<div>
						<label for="start_period_month">{{'g.month' | translate}}</label>
						<ng-select
							[(ngModel)]="filter.startPeriod.month"
							[items]="filtersList.startPeriod.months"
							name="start_period_month"
							bindValue="id"
							bindLabel="name"
							[clearable]="false"
							[ngStyle]="{'width': '150px'}"
							placeholder="{{'g.month_option' | translate}}"
							(click)="onSelectPeriod(); updateYearMonths('startPeriod')"
						></ng-select>
					</div>
				</div>
			</div>

			<!-- end Period -->
			<div class="filter">
				<strong>{{'g.to' | translate}}</strong>
				<div class="d-flex mt-2">
					<div class="mr-2">
						<label for="end_period_year">{{'g.year' | translate}}</label>
						<ng-select
							[(ngModel)]="filter.endPeriod.year"
							[items]="filtersList.endPeriod.years"
							name="end_period_year"
							bindValue="id"
							bindLabel="name"
							[clearable]="false"
							[ngStyle]="{'width': '150px'}"
							placeholder="{{'g.year_option' | translate}}"
							(click)="onSelectPeriod()"
						></ng-select>
					</div>
					<div>
						<label for="end_period_month">{{'g.month' | translate}}</label>
						<ng-select
							[(ngModel)]="filter.endPeriod.month"
							[items]="filtersList.endPeriod.months"
							name="end_period_month"
							bindValue="id"
							bindLabel="name"
							[clearable]="false"
							[ngStyle]="{'width': '150px'}"
							placeholder="{{'g.month_option' | translate}}"
							(click)="onSelectPeriod(); updateYearMonths('endPeriod')"
						></ng-select>
					</div>
				</div>
			</div>
		</div>

		<div class="custom-row align-items-end mt-2">
			<div class="filter">
				<button class="btn btn-primary" [disabled]="!this.isValidPeriod" (click)="getConnectivityVerificationLogs()">{{"g.search" | translate}}</button>
			</div>
		</div>
	</div>
</details>

<sct-custom-table
	[columnsConfig]="columnConfig"
	[data]="tableData"
	[config]="tableConfig"
></sct-custom-table>

<ng-template #noWarning>
	{{'---'}}
</ng-template>
